import React from 'react';
import ProductPage from '../components/product-page';

export default function PmsPage() {
  return (
    <ProductPage
      title="Benjamini Smart Switchboard"
      className="smart-power-commercial"
      demoLink="http://benjaminelectric.com/pms"
      images={[
        {
          src: 'be-switchboard.png',
          alt: 'Single section of grey switchboard',
        },
        {
          src: 'pms-overview.png',
          alt: 'Multiple meters showing readings for different breakers',
        },
        {
          src: 'pms-harmonics.png',
          alt: 'Bar graph of three phase harmonics',
        },
        {
          src: 'pmi-monthly-energy.png',
          alt: 'Bar graph of monthly energy comsumption for a single circuit',
        },
        {
          src: 'pms-mains-volts.png',
          alt: 'Gauges showing the Three Phase Voltage',
        },
        {
          src: 'pms-phasors.png',
          alt: 'System Phasor Diagram of amps and volts',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <>
              An effective addition to your Energy Management Systems. The
              Benjamin Smart Switchboard provides line-side power metering for
              all breakers.
            </>
          ),
        },
        {
          title: 'Features',
          id: 'features',
          content: (
            <ul>
              <li>Metering available on Mains and Branch Circuits</li>
              <li>
                Power use is logged allowing you to locate high use circuits,
                monitor changes, and diagnose problems.
              </li>
              <li>Use Harmonic Analysis to help diagnose problems.</li>
              <li>
                Industry Standard communication protocols are supported for
                integration with Building Management Systems or use the built in
                scheduler to control circuits.
              </li>
            </ul>
          ),
        },
        {
          title: 'Specifications',
          id: 'specifications',
          content: (
            <>
              <table>
                <tbody>
                  <tr>
                    <th rowspan="2">Voltage Ratings</th>
                    <td>120/240V 1Ø 3W</td>
                    <td>120/240V 1Ø 4W</td>
                    <td>208Y/120V 3Ø 4W</td>
                  </tr>
                  <tr>
                    <td>240V 3Ø 3W</td>
                    <td>480Y/277V 3Ø 4W</td>
                    <td>480V 3Ø 3W</td>
                  </tr>
                </tbody>
              </table>
              <table id="aic_ratings">
                <tbody>
                  <tr>
                    <th rowspan="2">AIC Ratings</th>
                    <td className="left-align">10kAIC to 200kAIC @240V</td>
                  </tr>
                  <tr>
                    <td className="left-align">
                      14kAIC@480Y/277V to 100kAIC@480V
                    </td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowspan="9">Power Measurement</th>
                    <th>Mains Current Accuracy</th>
                    <td className="left-align">
                      2% of reading from 1% to 10% of nominal rated current 1%
                      of reading from 10% to 100% of nominal rated current
                    </td>
                  </tr>
                  <tr>
                    <th>Mains Voltage Accuracy</th>
                    <td className="left-align">
                      0.2% of reading from 90-600 VAC Line to Neutral
                    </td>
                  </tr>
                  <tr>
                    <th>Mains Power Data</th>
                    <td className="left-align">
                      Voltage, Current, Hz, W, VA, VAR, PF, WHrs, VAHrs, VARHrs
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <th>Branch Current Accuracy</th>
                    <td className="left-align">
                      1% of reading from 0.15 Amps to 0.25 Amps 0.5% of reading
                      from 0.25 Amps to 400 Amps
                    </td>
                  </tr>
                  <tr>
                    <th>Branch Circuit Data</th>
                    <td className="left-align">
                      Voltage, Current, W, VA, VAR, PF, WHrs, VAHrs, VARHrs
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <th>Harmonic Analysis</th>
                    <td className="left-align">
                      Fundamental through 40th harmonic: Voltage, Current, Real
                      Power
                    </td>
                  </tr>
                  <tr>
                    <th>Data Update Rate</th>
                    <td className="left-align">
                      1 second for all real-time values
                    </td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <th rowspan="2">Mains Configurations</th>
                    <th>Lugs</th>
                    <td className="left-align">100 to 3000 Amp</td>
                  </tr>
                  <tr>
                    <th>Breaker</th>
                    <td className="left-align">100 to 2500 Amp</td>
                  </tr>
                </tbody>
              </table>
              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowspan="3">Branch Circuit Breaker Options</th>
                    <th>1 Pole</th>
                    <td className="left-align">15 Amp to 150 Amp</td>
                  </tr>
                  <tr>
                    <th>2 Pole</th>
                    <td className="left-align">15 Amp to 600 Amp</td>
                  </tr>
                  <tr>
                    <th>3 Pole</th>
                    <td className="left-align">15 Amp to 2500 Amp</td>
                  </tr>
                </tbody>
              </table>
              <table id="communications">
                <tbody>
                  <tr>
                    <th>Communications</th>
                    <td className="left-align">
                      Modbus 485, Modbus TCP/IP, Bacnet IP, EtherNet/IP
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ),
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/brochure-power-metered-switchboard.pdf">
                  Product Brochure
                </a>
              </li>
              <li>
                <a href="/downloads/specifications-power-metered-switchboard.pdf">
                  Specifications
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
